export class AbstractWebSocketService {
  constructor() {
    this.graphqlEndpoint = location.origin + "/graphql";
  }
  createWebSocketEndpoint() {
    return "ws" + this.graphqlEndpoint.slice(4).replace("graphql", "ws");
  }
}
